import * as React from 'react';

//Dialog
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

import {
  SortingState, EditingState, PagingState,
  IntegratedPaging, IntegratedSorting,FilteringState,IntegratedFiltering
} from '@devexpress/dx-react-grid';

import {
  Grid,
  Table, TableHeaderRow, TableEditRow, TableEditColumn,TableFilterRow,
  PagingPanel, DragDropProvider, TableColumnReordering,TableColumnResizing
} from '@devexpress/dx-react-grid-material-ui';

import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TableCell from '@material-ui/core/TableCell';
import LoaderButton from "../../components/LoaderButton";

import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import { withStyles } from '@material-ui/core/styles';

import FormLabel from '@material-ui/core/FormLabel';

import { API } from "aws-amplify";


const styles = theme => ({
  lookupEditCell: {
    paddingTop: theme.spacing.unit * 0.875,
    paddingRight: theme.spacing.unit,
    paddingLeft: theme.spacing.unit,
  },
  dialog: {
    width: 'calc(100% - 16px)',
  },
  inputRoot: {
    width: '100%',
  },
});

// const AddButton = () => (
//   <div style={{ textAlign: 'center' }}>
//     <LoaderButton
//                   block
//                   bsStyle="primary"
//                   bsSize="small"
//                   text="Add +"
//                   href = "/organizations/new"
//                   style={ {backgroundColor: '#00BCD4'} }
//                   />
//   </div>
// );

const AddButton = ({ onExecute }) => (
    <div style={{ textAlign: 'center' }}>
        <LoaderButton
                  block
                  bsStyle="primary"
                  bsSize="small"
                  text="Add +"
                  onClick={onExecute}
                  style={ {backgroundColor: '#00BCD4'} }
                  />
      {/* <Button
        color="primary"
        onClick={onExecute}
        title="Create new row"
        style={ {backgroundColor: '#00BCD4'} }
        >
        Add +
      </Button> */}
    </div>
  );

const EditButton = ({ onExecute }) => (
  <IconButton onClick={onExecute} title="Edit row">
    <EditIcon />
  </IconButton>
);

const DeleteButton = ({ onExecute }) => (
  <IconButton onClick={onExecute} title="Delete row">
    <DeleteIcon />
  </IconButton>
);

const CommitButton = ({ onExecute }) => (
  <IconButton onClick={onExecute} title="Save changes">
    <SaveIcon />
  </IconButton>
);

const CancelButton = ({ onExecute }) => (
  <IconButton color="secondary" onClick={onExecute} title="Cancel changes">
    <CancelIcon />
  </IconButton>
);

const commandComponents = {
  add: AddButton,
  edit: EditButton,
  delete: DeleteButton,
  commit: CommitButton,
  cancel: CancelButton,
};
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 'auto',
    },
  },
};

const Command = ({ id, onExecute }) => {
  const CommandButton = commandComponents[id];
  return (
    <CommandButton
      onExecute={onExecute}
    />
  );
};


var availableValues = {};

const LookupEditCellBase = ({
  availableColumnValues,value, onValueChange, classes,
}) => (
  <TableCell
    className={classes.lookupEditCell}
  >
          <Select
            value={value}
            onChange={event => onValueChange(event.target.value)}
            input={(
              <Input
                classes={{ root: classes.inputRoot }}
              />
            )}
            MenuProps={MenuProps}
          >
            {availableColumnValues.map(name => (
              <MenuItem
                key={name}
                value={name}
              >
                {name}
              </MenuItem>
            ))}
          </Select>
  </TableCell>
);
export const LookupEditCell = withStyles(styles, { name: 'organization' })(LookupEditCellBase);

const Cell = (props) => {
  // if (column.name === 'topic') {
  //   return <ProgressBarCell {...props} />;
  // }
  // if (column.name === 'country') {
  //   return <HighlightedCell {...props} />;
  // }
  return <Table.Cell {...props} />;
};

const EditCell = (props) => {
  const { column } = props;
  const availableColumnValues = availableValues[column.name];
  if (availableColumnValues) {
    return <LookupEditCell {...props} availableColumnValues={availableColumnValues}/>;
  }
  return <TableEditRow.Cell {...props} />;
};

const getRowId = row => row.name;

class Organization extends React.PureComponent  {  
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: 'name', title: 'Group Name' },
        { name: 'password', title: 'Password' },
      ],
      rows:[],
      sorting: [],
      editingRowIds: [],
      addedRows: [],
      rowChanges: {},
      currentPage: 0,
      deletingRows: [],
      pageSize: 50,
      pageSizes: [0,50,100],
      columnOrder: ['name', 'password'],
      defaultColumnWidths: [
        { columnName: 'name', width: 200 },
        { columnName: 'password', width:  200 }
      ],
      open:false
    };

    const getStateDeletingRows = () => {
      const { deletingRows } = this.state;
      return deletingRows;
    };
    
    const getStateRows = () => {
      const { rows } = this.state;
      return rows;
    };

    
    this.handleClose =  open => { this.setState({ open: false });  
      window.location.reload();
    };
    this.changeSorting = sorting => this.setState({ sorting });
    this.changeEditingRowIds = editingRowIds => this.setState({ editingRowIds });
    this.changeAddedRows = addedRows => this.setState({
      addedRows: addedRows.map(row => (Object.keys(row).length ? row : {
        // amount: 0,
        // discount: 0,
        // saleDate: new Date().toISOString().split('T')[0],
        // product: availableValues.product[0],
        // region: availableValues.region[0],
        // customer: availableValues.customer[0],
      })),
    });
    this.changeRowChanges = rowChanges => this.setState({ rowChanges });
    this.changeCurrentPage = currentPage => this.setState({ currentPage });
    this.changePageSize = pageSize => this.setState({ pageSize });
    this.commitChanges = ({ added, changed, deleted }) => {
      let { rows } = this.state;
      if (added) {
        const startingAddedId = rows.length > 0 ? rows[rows.length - 1].id + 1 : 0;
        rows = [
          ...rows,
          ...added.map((row, index) => ({
            id: startingAddedId + index,
            ...row,
          })),
        ];
        this.createOrganization(rows, added);

      }
      if (changed) {
  
        rows = rows.map(row =>(changed[row.name] ? { ...row, ...changed[row.name] } : row));
        this.updateOrganization(rows, changed);

      }
      this.setState({ rows, deletingRows: deleted || getStateDeletingRows() });

    };
    // Call POST API to Add new entry to organization table.
    this.createOrganization=async (rows, addedRow)=>{

        await API.post("organization", "/organization", {body: addedRow });
      }

    // Call POST API to edit existing entry on organization table.
    this.updateOrganization=async (rows, changedRow)=>{
      var updatedRow=[];

      for(var item in changedRow)
      {
        if(!changedRow[item])
        {
            return;
        }
        if(Object.keys(changedRow[item])==="name")
        return this.setState({open:true});

      }

      rows.map((row) =>{
          if(changedRow[row.name] )
           {
             updatedRow= row;
           }
        });

      await API.post("organization", "/organization", {body: updatedRow });
    }
    this.cancelDelete = () => this.setState({ deletingRows: [] });
    this.deleteRows = () => {

      const rows = getStateRows().slice();
      getStateDeletingRows().forEach((rowId) => {
        const index = rows.findIndex(row => row.name === rowId);
        const name = rows[index].name;
        //Delete from the database
        API.del("organization", `/organization/${name}`);

        if (index > -1) {
          rows.splice(index, 1);
        }
      });
      this.setState({ rows, deletingRows: [] });


    };
    this.changeColumnOrder = (order) => {
      this.setState({ columnOrder: order });
    };
  }

    //Call GET Organization API
    async componentDidMount() {
      if (!this.props.isAuthenticated) {
        return;
      }
    
      try {
        const rows =  await this.getOrganization();
        this.setState({ rows });
        
       } catch (e) {
        alert(e);
      }
  
    }
    
    // make call to Get API

      getOrganization() {
      return API.get("organization", "/organization");
    }



  render() {
    const {
      classes,
    } = this.props;
    const {
      rows,
      columns,
      sorting,
      editingRowIds,
      addedRows,
      rowChanges,
      currentPage,
      deletingRows,
      pageSize,
      pageSizes,
      columnOrder,
      defaultColumnWidths,
      open
      // currencyColumns,
      // percentColumns,
    } = this.state;
 

    return (

      <Paper>
          <FormLabel style={{marginLeft:20,  marginTop:40, fontSize: 32, marginBottom:40}}>Affiliated Groups</FormLabel>

        <Grid
          rows={rows}
          columns={columns}
          getRowId={getRowId}
        >
          <SortingState
            sorting={sorting}
            onSortingChange={this.changeSorting}
          />
          <PagingState
            currentPage={currentPage}
            onCurrentPageChange={this.changeCurrentPage}
            pageSize={pageSize}
            onPageSizeChange={this.changePageSize}
          />
          <FilteringState />

          <IntegratedSorting />
          <IntegratedPaging />
          <IntegratedFiltering />
          {/* <CurrencyTypeProvider for={currencyColumns} />
          <PercentTypeProvider for={percentColumns} /> */}

          <EditingState
            editingRowIds={editingRowIds}
            onEditingRowIdsChange={this.changeEditingRowIds}
            rowChanges={rowChanges}
            onRowChangesChange={this.changeRowChanges}
            addedRows={addedRows}
            onAddedRowsChange={this.changeAddedRows}
            onCommitChanges={this.commitChanges}
          />

          <DragDropProvider />


          <Table
            cellComponent={Cell}
          />

          <TableColumnReordering
            order={columnOrder}
            onOrderChange={this.changeColumnOrder}
          />
          <TableColumnResizing
            defaultColumnWidths={defaultColumnWidths}
          />
          <TableHeaderRow showSortingControls />
          <TableEditRow
            cellComponent={EditCell}
          />
           <TableFilterRow />

          <TableEditColumn
            width={120}
            showAddCommand={!addedRows.length}
            showEditCommand
            showDeleteCommand
            commandComponent={Command}
          />
          <PagingPanel
            pageSizes={pageSizes}
          />
        </Grid>

        <Dialog
          open={!!deletingRows.length}
          onClose={this.cancelDelete}
          classes={{ paper: classes.dialog }}
        >
          <DialogTitle>
            Delete Row
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure to delete the following row?
            </DialogContentText>
            <Paper>
              <Grid
                rows={rows.filter(row => deletingRows.indexOf(row.name) > -1)}
                columns={columns}
              >
                {/* <CurrencyTypeProvider for={currencyColumns} />
                <PercentTypeProvider for={percentColumns} /> */}
                <Table
                  cellComponent={Cell}
                />
                <TableHeaderRow />
              </Grid>
            </Paper>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.cancelDelete} color="primary">
                Cancel
            </Button>
            <Button onClick={this.deleteRows} color="secondary">
              Delete
            </Button>
          </DialogActions>
        </Dialog>

         <Dialog
          open={this.state.open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Warning"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            You can only modify the password.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button open ={open} onClick={this.handleClose} color="primary">
              Okay
            </Button>
          </DialogActions>
        </Dialog>

      </Paper>
    );
  }
}

export default withStyles(styles, { name: 'organizations' })(Organization);

